import React from "react";
import ReactECharts from "echarts-for-react";
import ReactHTMLParser from "react-html-parser";
import close from "../../minimise_button.png";

class BarChart extends React.Component {
  constructor(props) {
    super(props);

    const isHorizontal = props.vertical === false; // Determines the bar orientation
    this.state = {
      option: {
        color: ['#E27A6C', '#F3F4A3', '#B1F484', '#6FCADD'],
        title: {
          text: ReactHTMLParser(props.title),
          left: 'left',
          top: "2%",
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold',
            color: '#263238',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow', // default type is 'line', 'shadow' for bar chart
          },
        },
        legend: {
          top: 'top',
          right: '20%',
        },
        grid: {
          left: '1%',
          right: '2%',
          bottom: '4%',
          containLabel: true, // Ensures labels fit within the chart area
        },
        xAxis: {
          type: isHorizontal ? 'category' : 'value', // Adjust orientation

          data: isHorizontal ?  props.categories:undefined,
          name: isHorizontal ?  "Week":this.props.yaxisTitle,
          nameLocation: "center",
          nameTextStyle: {
            fontSize: 12,
            color: '#000',
            fontWeight: 'bold',
          },
          nameGap: 20,
          axisLabel: {
            formatter: (value) => value,
          },
          max: this.props.vertical? 100 : null, // Max = 100 if y-axis is value

         
        },
        yAxis: {
          type: isHorizontal ? 'value': 'category' , // Adjust orientation

          data: isHorizontal ?  undefined:props.categories ,
          //name: isHorizontal ?  this.props.yaxisTitle:"Week" ,
          nameLocation: "center",
          nameTextStyle: {
            fontSize: 12,
            color: '#000',
            fontWeight: 'bold',
          },
          axisLabel: {
            formatter: (value) => value,
          },
          max: this.props.vertical? 22 : null, // Max = 100 if y-axis is value

       
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100,
          },
        ],
        toolbox: {
          feature: {
            magicType: {
              type: ["bar", "line"],
              title: {
                line: "Line Chart",
                bar: "Bar Chart",
              },
            },
            restore: {
              title: "Restore",
            },
            myClose: {
              show: true,
              title: "Minimize",
              icon: `image://${close}`,
              onclick: this.props.toggleVisibleGraphPanel,
            },
          },
        },
        series: props.data.map((seriesItem) => ({
          name: seriesItem.name,
          type: 'bar',
          stack: 'total',
          barWidth: '55%', // Equivalent to columnWidth
          emphasis: {
            focus: 'series',
          },
          label: {
            show: true,
           // formatter: (params) => Math.round(params.value) + '%',
           formatter: (params) => {
            // Condition to show labels based on values or indexes
            if (params.value > 10) {  // Show label only if the value is greater than 20
              return Math.round(params.value) + '%';
            }
            return '';  // Return an empty string to hide labels below the threshold
          },
           color: '#000',
          },
          data: seriesItem.data,
        })),
      },
    };
  }

  render() {
    console.log("props.yAxisType",this.props.yAxisType,this.props.vertical)
    return (
      <ReactECharts
        option={this.state.option}
        style={{ height: "300px", width: "100%" }}
      />
    );
  }
}

export default BarChart;
